import React, { useMemo, useState } from 'react';
import { CnDialog, CnDrawer } from '@sto/cn-ui';
import CMarkdown from '../CMarkdown';
import CTable from '../CTable';
import CBi from '../CBi';
import CList from '../CList';
import styles from './index.module.scss';

const RenderContent = ({ content, type, title }) => {
  switch (type) {
    case 'TABLE':
      return <CTable content={content} />;
    case 'DATA_JSON':
      return <CBi content={content} question="" />;
    case 'LIST':
      return <CList content={content} />;
    default:
      // 默认使用 Markdown 渲染
      if (typeof content === 'string') {
        return <CMarkdown content={content} />;
      }
      console.error('ERROR: 未能匹配到组件', content, type);
      return <span>未能匹配到组件</span>;
  }
}

/**
 * 参考资料
 * @param content 参考内容
 * @returns 
 */
const CReferences = ({ content, requestId }) => {
  const [info, setInfo] = useState(null);

  // 渲染详情
  const renderDetails = useMemo(() => {
    const { title, type, detail } = info || {};
    const { content } = detail || {};
    if (!content)  return null;
    if (type === 'DIALOG' || type === 'DRAWER') {
      CnDialog.show({
        title: (
          <div className={styles.dialogTitle} title={title}>
            {title}
          </div>
        ),
        content: (
          <div className={styles.dialogContent}>
            <RenderContent {...detail} />
          </div>
        ),
        width: 800,
        footer: false,
        onClose: () => setInfo(null),
      });
      return null;
    } 
    // 先不用抽屉框展示
    // else if (type === 'DRAWER') {
    //   return <CnDrawer 
    //     visible
    //     title={
    //       <div className={styles.dialogTitle} title={title}>
    //         {title}
    //       </div>
    //     }
    //     onClose={() => setInfo(null)}
    //     width={940}
    //   >
    //     <div className={styles.drawerContent}>
    //       <RenderContent {...detail} />
    //     </div>
    //   </CnDrawer>;
    // } 
    else if (type === 'LINK') {
      window.open(content, '_blank');
      setInfo(null);
      return null;
    }
    return null;
  }, [info]);

  return (
    <div className={styles.referencesBox}>
      <div className={styles.referencesTitle}>参考资料：</div>
      <div className={styles.referencesListBox}>
        <div className={styles.referencesList}>
          {content?.map((item: any, index: number) => (
            <div key={index} className={styles.referencesItem} onClick={() => setInfo(item)}>
              {item.title}
            </div>
          ))}
        </div>
      </div>
      {renderDetails}
    </div>
  )
}

export default CReferences;